import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import { useAppSelector } from 'store';
import { selectUserDocuments } from 'store/user';

export const DocumentsUploadedList = () => {
  const docs = useAppSelector(selectUserDocuments);

  if (!docs.length) return null;

  return (
    <div>
      <div className="_form-title">
        <FormattedMessage id="page.documents.uploaded" defaultMessage="Uploaded documents" />
      </div>
      <ol>
        {docs.map((d: any) => (
          <li key={d.id}>
            <b>{d.file_name}</b> {moment.unix(d.created_at).format('DD.MM.YYYY HH:mm')} ({d.status})
          </li>
        ))}
      </ol>
    </div>
  );
};
